// import React, { useState } from 'react';
// import { MdMenu } from 'react-icons/md'; // Import MdMenu for hamburger icon
// import { FaTimes } from 'react-icons/fa';
// import './index.css' // Import FaTimes for closing the mobile menu
// import { Link } from 'react-router-dom';
// import logo1 from '../Images/logo1.jpeg'
// import lionslogo from '../Images/lionslogo.png'
// import lbnlogo from '../Images/lbnlogo.jpeg';
// import lbnlogo1 from '../Images/icon.png';
// const Navbar = () => {
//     const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//     const toggleMenu = () => {
//         setIsMobileMenuOpen(!isMobileMenuOpen);
//     };

//     return (
//         <nav className="navbar">
//             <div className="container">
//                 <img src={lbnlogo} alt="Lions Club Logo" className="logo1" />
                
//                 {/* Desktop Navigation Links */}
//                 <div className="desktop-nav">
//                     <div className="nav-links">
//                     <Link to="/">Home</Link>           
//       <Link to="/products">Product</Link>
//       <Link to="/contact">Contact Us</Link> 
//                     </div>
//                     <div style={{marginLeft:15}}>
//                <Link to='/login'> <button className="login-btnn1">Login/Signup</button></Link>   
//                     </div>
//                 </div>

//                 {/* Mobile Hamburger Icon */}
//                 <div className="hamburger" onClick={toggleMenu}>
                    
//                     <MdMenu size={30} />
//                 </div>

//                 {/* Mobile Menu */}
//                 <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
                    
//                     <div className="close-btn" onClick={toggleMenu}>
//                         <FaTimes size={30} />
                        
//                     </div>
//                     <div className="mobile-nav-links">
//                     <Link to="/"  onClick={toggleMenu}>Home</Link>           {/* Link to Home route */}
//       <Link to="/products"  onClick={toggleMenu}>Product</Link> {/* Scroll to Product section */}
//       <Link to="/contact"  onClick={toggleMenu}>Contact Us</Link> {/* Scroll to Contact Us section */}
//                     </div>
//             <Link to='/login' style={{textAlign:'center'}} onClick={toggleMenu}><button className="login-btnn" style={{color:'white'}}>Login/Signup</button></Link>
//                 </div>

//                 <img src={lbnlogo1} alt="Another Logo" className="logo" />
//             </div>
//         </nav>
//     );
// };

// export default Navbar;


// import React, { useState } from 'react';
// import { MdMenu } from 'react-icons/md';
// import { FaTimes } from 'react-icons/fa';
// import { Link, useLocation } from 'react-router-dom';
// import './index.css';

// import logo1 from '../Images/logo1.jpeg';
// import lionslogo from '../Images/lionslogo.png';
// import lbnlogo from '../Images/lbnlogo.jpeg';
// import lbnlogo1 from '../Images/icon.png';

// const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   const location = useLocation();

//   const toggleMenu = () => {
//     setIsMobileMenuOpen(!isMobileMenuOpen);
//   };

//   const isActive = (path) => location.pathname === path;

//   return (
//     <>
//       <nav
//         className="navbar"
//         style={{
//           position: 'sticky',
//           top: 0,
//           zIndex: 999,
//           background: 'rgba(255,255,255,0.96)',
//           backdropFilter: 'blur(12px)',
//           boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//           borderBottom: '1px solid rgba(0,0,0,0.06)',
//         }}
//       >
//         <div
//           className="container"
//           style={{
//             maxWidth: '1350px',
//             margin: '0 auto',
//             padding: '0 20px',
//             height: '78px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             gap: '15px',
//           }}
//         >
//           {/* Left Logo */}
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '12px',
//             }}
//           >
//             <img
//               src={lbnlogo}
//               alt="Lions Club Logo"
//               className="logo1"
//               style={{
//                 width: '58px',
//                 height: '58px',
//                 borderRadius: '50%',
//                 objectFit: 'cover',
//                 border: '3px solid #f59e0b',
//                 boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
//               }}
//             />

//             <div className="desktop-brand-name">
//               <h3
//                 style={{
//                   margin: 0,
//                   fontSize: '20px',
//                   fontWeight: '700',
//                   color: '#1e3a8a',
//                   lineHeight: '1.1',
//                 }}
//               >
//                 LBN
//               </h3>

//               <p
//                 style={{
//                   margin: 0,
//                   fontSize: '12px',
//                   color: '#666',
//                   fontWeight: '500',
//                 }}
//               >
//                 Official Portal
//               </p>
//             </div>
//           </div>

//           {/* Desktop Navigation */}
//           <div
//             className="desktop-nav"
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '35px',
//             }}
//           >
//             <div
//               className="nav-links"
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '28px',
//               }}
//             >
//               <Link
//                 to="/"
//                 style={{
//                   textDecoration: 'none',
//                   color: isActive('/') ? '#1e3a8a' : '#444',
//                   fontWeight: '600',
//                   fontSize: '15px',
//                   position: 'relative',
//                   paddingBottom: '4px',
//                   transition: '0.3s',
//                 }}
//               >
//                 Home

//                 <span
//                   style={{
//                     position: 'absolute',
//                     bottom: 0,
//                     left: 0,
//                     width: isActive('/') ? '100%' : '0%',
//                     height: '2px',
//                     background: '#1e3a8a',
//                     transition: '0.3s',
//                   }}
//                 />
//               </Link>

//               <Link
//                 to="/products"
//                 style={{
//                   textDecoration: 'none',
//                   color: isActive('/products') ? '#1e3a8a' : '#444',
//                   fontWeight: '600',
//                   fontSize: '15px',
//                   position: 'relative',
//                   paddingBottom: '4px',
//                   transition: '0.3s',
//                 }}
//               >
//                 Product

//                 <span
//                   style={{
//                     position: 'absolute',
//                     bottom: 0,
//                     left: 0,
//                     width: isActive('/products') ? '100%' : '0%',
//                     height: '2px',
//                     background: '#1e3a8a',
//                     transition: '0.3s',
//                   }}
//                 />
//               </Link>

//               <Link
//                 to="/contact"
//                 style={{
//                   textDecoration: 'none',
//                   color: isActive('/contact') ? '#1e3a8a' : '#444',
//                   fontWeight: '600',
//                   fontSize: '15px',
//                   position: 'relative',
//                   paddingBottom: '4px',
//                   transition: '0.3s',
//                 }}
//               >
//                 Contact Us

//                 <span
//                   style={{
//                     position: 'absolute',
//                     bottom: 0,
//                     left: 0,
//                     width: isActive('/contact') ? '100%' : '0%',
//                     height: '2px',
//                     background: '#1e3a8a',
//                     transition: '0.3s',
//                   }}
//                 />
//               </Link>
//             </div>

//             {/* Login Button */}
//             <Link to="/login" style={{ textDecoration: 'none' }}>
//               <button
//                 className="login-btnn1"
//                 style={{
//                   border: 'none',
//                   outline: 'none',
//                   padding: '12px 24px',
//                   borderRadius: '999px',
//                   background:
//                     'linear-gradient(135deg,#fbbf24,#f59e0b)',
//                   color: '#fff',
//                   fontWeight: '700',
//                   cursor: 'pointer',
//                   fontSize: '14px',
//                   boxShadow: '0 8px 18px rgba(245,158,11,0.35)',
//                   transition: '0.3s',
//                 }}
//               >
//                 Login / Signup
//               </button>
//             </Link>
//           </div>

//           {/* Right Logo */}
//           <div
//             className="right-logo-wrapper"
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '12px',
//             }}
//           >
//             <img
//               src={lbnlogo1}
//               alt="Another Logo"
//               className="logo"
//               style={{
//                 width: '52px',
//                 height: '52px',
//                 borderRadius: '50%',
//                 objectFit: 'cover',
//                 border: '3px solid #1e3a8a',
//                 boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
//               }}
//             />

//             {/* Mobile Menu Icon */}
//             <div
//               className="hamburger"
//               onClick={toggleMenu}
//               style={{
//                 display: 'none',
//                 cursor: 'pointer',
//                 color: '#1e3a8a',
//               }}
//             >
//               <MdMenu size={32} />
//             </div>
//           </div>
//         </div>

//         {/* Mobile Sidebar */}
//         <div
//           className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}
//           style={{
//             position: 'fixed',
//             top: 0,
//             right: isMobileMenuOpen ? '0' : '-100%',
//             width: '280px',
//             height: '100vh',
//             background: '#ffffff',
//             zIndex: 9999,
//             transition: '0.35s ease-in-out',
//             boxShadow: '-10px 0 30px rgba(0,0,0,0.15)',
//             padding: '25px 22px',
//             display: 'flex',
//             flexDirection: 'column',
//           }}
//         >
//           {/* Close */}
//           <div
//             className="close-btn"
//             onClick={toggleMenu}
//             style={{
//               alignSelf: 'flex-end',
//               cursor: 'pointer',
//               color: '#1e3a8a',
//               marginBottom: '25px',
//             }}
//           >
//             <FaTimes size={28} />
//           </div>

//           {/* Mobile Logo */}
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '12px',
//               marginBottom: '35px',
//             }}
//           >
//             <img
//               src={lbnlogo}
//               alt=""
//               style={{
//                 width: '55px',
//                 height: '55px',
//                 borderRadius: '50%',
//                 border: '3px solid #f59e0b',
//               }}
//             />

//             <div>
//               <h3
//                 style={{
//                   margin: 0,
//                   color: '#1e3a8a',
//                   fontSize: '18px',
//                 }}
//               >
//                 LBN Portal
//               </h3>

//               <p
//                 style={{
//                   margin: 0,
//                   color: '#777',
//                   fontSize: '12px',
//                 }}
//               >
//                 Welcome Back
//               </p>
//             </div>
//           </div>

//           {/* Mobile Links */}
//           <div
//             className="mobile-nav-links"
//             style={{
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '14px',
//             }}
//           >
//             <Link
//               to="/"
//               onClick={toggleMenu}
//               style={{
//                 textDecoration: 'none',
//                 color: isActive('/') ? '#1e3a8a' : '#444',
//                 background: isActive('/')
//                   ? '#eff6ff'
//                   : 'transparent',
//                 padding: '14px 16px',
//                 borderRadius: '12px',
//                 fontWeight: '600',
//                 transition: '0.3s',
//               }}
//             >
//               Home
//             </Link>

//             <Link
//               to="/products"
//               onClick={toggleMenu}
//               style={{
//                 textDecoration: 'none',
//                 color: isActive('/products')
//                   ? '#1e3a8a'
//                   : '#444',
//                 background: isActive('/products')
//                   ? '#eff6ff'
//                   : 'transparent',
//                 padding: '14px 16px',
//                 borderRadius: '12px',
//                 fontWeight: '600',
//                 transition: '0.3s',
//               }}
//             >
//               Product
//             </Link>

//             <Link
//               to="/contact"
//               onClick={toggleMenu}
//               style={{
//                 textDecoration: 'none',
//                 color: isActive('/contact')
//                   ? '#1e3a8a'
//                   : '#444',
//                 background: isActive('/contact')
//                   ? '#eff6ff'
//                   : 'transparent',
//                 padding: '14px 16px',
//                 borderRadius: '12px',
//                 fontWeight: '600',
//                 transition: '0.3s',
//               }}
//             >
//               Contact Us
//             </Link>
//           </div>

//           {/* Mobile Button */}
//           <Link
//             to="/login"
//             onClick={toggleMenu}
//             style={{
//               textDecoration: 'none',
//               marginTop: '30px',
//             }}
//           >
//             <button
//               className="login-btnn"
//               style={{
//                 width: '100%',
//                 border: 'none',
//                 outline: 'none',
//                 padding: '14px',
//                 borderRadius: '999px',
//                 background:
//                   'linear-gradient(135deg,#fbbf24,#f59e0b)',
//                 color: '#fff',
//                 fontWeight: '700',
//                 fontSize: '15px',
//                 cursor: 'pointer',
//                 boxShadow: '0 8px 18px rgba(245,158,11,0.35)',
//               }}
//             >
//               Login / Signup
//             </button>
//           </Link>
//         </div>

//         {/* Mobile Overlay */}
//         {isMobileMenuOpen && (
//           <div
//             onClick={toggleMenu}
//             style={{
//               position: 'fixed',
//               inset: 0,
//               background: 'rgba(0,0,0,0.45)',
//               zIndex: 9998,
//             }}
//           />
//         )}
//       </nav>

//       {/* Responsive CSS */}
//       <style>
//         {`
//           @media (max-width: 900px) {
//             .desktop-nav {
//               display: none !important;
//             }

//             .hamburger {
//               display: block !important;
//             }

//             .desktop-brand-name {
//               display: none;
//             }

//             .logo {
//               width: 45px !important;
//               height: 45px !important;
//             }

//             .logo1 {
//               width: 50px !important;
//               height: 50px !important;
//             }

//             .container {
//               height: 72px !important;
//             }
//           }

//           @media (max-width: 500px) {
//             .mobile-nav {
//               width: 85% !important;
//             }

//             .container {
//               padding: 0 14px !important;
//             }

//             .logo {
//               width: 42px !important;
//               height: 42px !important;
//             }

//             .logo1 {
//               width: 46px !important;
//               height: 46px !important;
//             }
//           }
//         `}
//       </style>
//     </>
//   );
// };

// export default Navbar;

import React, { useState } from 'react';
import { MdMenu } from 'react-icons/md';
import { FaTimes } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import './index.css';

import lbnlogo from '../Images/lbnlogo.jpeg';
import lbnlogo1 from '../Images/icon.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const location = useLocation();

  const openMenu = () => {
    setIsMobileMenuOpen(true);
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 999,
          width: '100%',
          background: 'rgba(255,255,255,0.96)',
          backdropFilter: 'blur(12px)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          borderBottom: '1px solid rgba(0,0,0,0.06)',
        }}
      >
        <div
          className="navbar-container"
          style={{
            maxWidth: '1350px',
            margin: '0 auto',
            padding: '0 20px',
            height: '78px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '15px',
          }}
        >
          {/* Left Side */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            <img
              src={lbnlogo}
              alt="logo"
              className="logo1"
              style={{
                width: '85px',
                height: '58px',
                borderRadius: '50%',
                objectFit: 'contain',
                border: '3px solid #f59e0b',
                boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
              }}
            />

            <div className="desktop-brand-name">
              {/* <h3
                style={{
                  margin: 0,
                  fontSize: '20px',
                  fontWeight: '700',
                  color: '#1e3a8a',
                  lineHeight: '1.1',
                }}
              >
                LBN
              </h3> */}

              {/* <p
                style={{
                  margin: 0,
                  fontSize: '12px',
                  color: '#666',
                  fontWeight: '500',
                }}
              >
                Official Portal
              </p> */}
            </div>
          </div>

          {/* Desktop Nav */}
          <div
            className="desktop-nav"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '35px',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '28px',
              }}
            >
              <Link
                to="/"
                style={{
                  textDecoration: 'none',
                  color: isActive('/') ? '#1e3a8a' : '#444',
                  fontWeight: '600',
                  fontSize: '15px',
                }}
              >
                Home
              </Link>

              <Link
                to="/products"
                style={{
                  textDecoration: 'none',
                  color: isActive('/products') ? '#1e3a8a' : '#444',
                  fontWeight: '600',
                  fontSize: '15px',
                }}
              >
                Product
              </Link>

              <Link
                to="/contact"
                style={{
                  textDecoration: 'none',
                  color: isActive('/contact') ? '#1e3a8a' : '#444',
                  fontWeight: '600',
                  fontSize: '15px',
                }}
              >
                Contact Us
              </Link>
            </div>

            <Link to="/login" style={{ textDecoration: 'none' }}>
              <button
                style={{
                  border: 'none',
                  outline: 'none',
                  padding: '12px 24px',
                  borderRadius: '999px',
                  background:
                    'linear-gradient(135deg,#fbbf24,#f59e0b)',
                  color: '#fff',
                  fontWeight: '700',
                  cursor: 'pointer',
                  fontSize: '14px',
                  boxShadow: '0 8px 18px rgba(245,158,11,0.35)',
                }}
              >
                Login / Signup
              </button>
            </Link>
          </div>

          {/* Right */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
            }}
          >
            <img
              src={lbnlogo1}
              alt="logo"
              className="logo"
              style={{
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '3px solid #1e3a8a',
                boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
                display:'flex'
              }}
            />

            {/* Hamburger */}
            <div
              className="hamburger"
              onClick={openMenu}
              style={{
                display: 'none',
                cursor: 'pointer',
                color: '#1e3a8a',
              }}
            >
              <MdMenu size={32} />
            </div>
          </div>
        </div>
      </nav>

      {/* OVERLAY */}
      {isMobileMenuOpen && (
        <div
          onClick={closeMenu}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            background: 'rgba(0,0,0,0.45)',
            zIndex: 9998,
          }}
        />
      )}

      {/* MOBILE SIDEBAR */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '280px',
          maxWidth: '85%',
          height: '100vh',
          background: '#fff',
          zIndex: 9999,
          padding: '25px 22px',
          boxShadow: '-10px 0 30px rgba(0,0,0,0.15)',

          display: isMobileMenuOpen ? 'flex' : 'none',
          flexDirection: 'column',
        }}
      >
        {/* Close Button */}
        <div
          onClick={closeMenu}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            cursor: 'pointer',
            marginBottom: '25px',
            color: '#1e3a8a',
          }}
        >
          <FaTimes size={28} />
        </div>

        {/* Mobile Logo */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '35px',
          }}
        >
          <img
            src={lbnlogo}
            alt="logo"
            style={{
              width: '85px',
              height: '55px',
              borderRadius: '50%',
              border: '3px solid #f59e0b',
              objectFit:'contain'
            }}
          />

          <div>
            {/* <h3
              style={{
                margin: 0,
                color: '#1e3a8a',
                fontSize: '18px',
              }}
            >
              LBN 
            </h3> */}

            {/* <p
              style={{
                margin: 0,
                color: '#777',
                fontSize: '12px',
              }}
            >
              Welcome Back
            </p> */}
          </div>
        </div>

        {/* Mobile Links */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
          }}
        >
          <Link
            to="/"
            onClick={closeMenu}
            style={{
              textDecoration: 'none',
              color: isActive('/') ? '#1e3a8a' : '#444',
              background: isActive('/') ? '#eff6ff' : 'transparent',
              padding: '14px 16px',
              borderRadius: '12px',
              fontWeight: '600',
            }}
          >
            Home
          </Link>

          <Link
            to="/products"
            onClick={closeMenu}
            style={{
              textDecoration: 'none',
              color: isActive('/products')
                ? '#1e3a8a'
                : '#444',
              background: isActive('/products')
                ? '#eff6ff'
                : 'transparent',
              padding: '14px 16px',
              borderRadius: '12px',
              fontWeight: '600',
            }}
          >
            Product
          </Link>

          <Link
            to="/contact"
            onClick={closeMenu}
            style={{
              textDecoration: 'none',
              color: isActive('/contact')
                ? '#1e3a8a'
                : '#444',
              background: isActive('/contact')
                ? '#eff6ff'
                : 'transparent',
              padding: '14px 16px',
              borderRadius: '12px',
              fontWeight: '600',
            }}
          >
            Contact Us
          </Link>
        </div>

        {/* Button */}
        <Link
          to="/login"
          onClick={closeMenu}
          style={{
            textDecoration: 'none',
            marginTop: '30px',
          }}
        >
          <button
            style={{
              width: '100%',
              border: 'none',
              outline: 'none',
              padding: '14px',
              borderRadius: '999px',
              background:
                'linear-gradient(135deg,#fbbf24,#f59e0b)',
              color: '#fff',
              fontWeight: '700',
              fontSize: '15px',
              cursor: 'pointer',
              boxShadow: '0 8px 18px rgba(245,158,11,0.35)',
            }}
          >
            Login / Signup
          </button>
        </Link>
      </div>

      {/* Responsive */}
      <style>
        {`
          @media (max-width: 900px) {

            .desktop-nav {
              display: none !important;
            }

            .hamburger {
              display: block !important;
            }

            .desktop-brand-name {
              display: none !important;
            }

            .logo {
              width: 45px !important;
              height: 45px !important;
            }

            .logo1 {
              width: 50px !important;
              height: 50px !important;
            }

            .navbar-container {
              height: 72px !important;
              padding: 0 14px !important;
            }
          }

          @media (max-width: 500px) {

            .logo {
              width: 42px !important;
              height: 42px !important;
            }

            .logo1 {
              width: 46px !important;
              height: 46px !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default Navbar;